/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import {Reducer} from 'redux';
import {
  NETWORK_THROUGHPUT_REPORT_FETCHING,
  NETWORK_THROUGHPUT_REPORT_FETCHING_DONE,
  NETWORK_THROUGHPUT_REPORT_FETCHING_ERROR,
  qosActionsType
} from 'store/action';

import {IThroughputRecord} from 'interfaces/qosProps';
import {IPortalError} from 'utility/error-handler';

export interface IQosState {
  throughput: {
    isFetching: boolean;
    error: null | IPortalError;
    data: IThroughputRecord[];
  };
}

const defaultState = {
  throughput: {
    isFetching: false,
    error: null,
    data: []
  }
};
const qosReducer: Reducer<Readonly<IQosState>, qosActionsType> = (
  state: IQosState = defaultState,
  action: qosActionsType
) => {
  switch (action.type) {
    case NETWORK_THROUGHPUT_REPORT_FETCHING: {
      return {
        ...state,
        [action.kind]: {
          ...state[action.kind],
          isFetching: true,
          error: null
        }
      };
    }

    case NETWORK_THROUGHPUT_REPORT_FETCHING_DONE: {
      return {
        ...state,
        [action.kind]: {
          ...state[action.kind],
          isFetching: false,
          error: null,
          ...action.payload
        }
      };
    }

    case NETWORK_THROUGHPUT_REPORT_FETCHING_ERROR: {
      return {
        ...state,
        [action.kind]: {
          ...state[action.kind],
          isFetching: false,
          error: action.error
        }
      };
    }

    default:
      return state;
  }
};

export default qosReducer;